module.exports = __webpack_public_path__ + "assets/img/2-3-en.fbd56695.png";